"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Mobile = function Mobile() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.273 0H16a3.273 3.273 0 013.273 3.273v17.454A3.273 3.273 0 0116 24H7.273A3.273 3.273 0 014 20.727V3.273A3.273 3.273 0 017.273 0zm9.818 4.364A1.09 1.09 0 0016 3.273H7.273a1.09 1.09 0 00-1.091 1.09v15.273c0 .603.488 1.091 1.09 1.091H16a1.09 1.09 0 001.09-1.09V4.363z",
    clipRule: "evenodd"
  });
};

exports.Mobile = Mobile;